import { trigger, state, style, transition,
         animate, AnimationTriggerMetadata } from '@angular/animations';

export function baseLayersSwitcherSlideInOut(): AnimationTriggerMetadata {

  return trigger('baseLayerSwitcherState', [
    state('collapseIcon', style({
      height: '40px',
      width: '40px',
      overflow: 'hidden'
    })),
    state('collapseMap', style({
      height: '85px',
      overflow: 'hidden'
    })),
    state('expand',   style({
      overflow: 'hidden'
    })),
    transition('collapse => expand', animate('200ms')),
    transition('expand => collapse', animate('200ms'))
  ]);
};



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/map/baselayers-switcher/baselayers-switcher.animation.ts